"use client";

import { useEffect, useRef } from "react";

const ENABLED = process.env.NODE_ENV !== "production";

// Counts how many instances of each label have been created in this document.
// A number above 1 means the component was remounted rather than retained.
const instanceCounts: Record<string, number> = {};

// Development-only mount tracing for the header tree.
// A remount during navigation is what resets the open submenu, the scroll
// hide/show state and the auth skeleton, so this logs where each instance was
// created and which navigation destroyed it.
// Remove once the shell migration is verified.
export default function useMountLog(label: string) {
    const mountedOn = useRef("");
    const instanceId = useRef(0);

    useEffect(() => {
        if (!ENABLED) return;

        const here = () => window.location.pathname + window.location.search;

        instanceCounts[label] = (instanceCounts[label] ?? 0) + 1;
        instanceId.current = instanceCounts[label];
        mountedOn.current = here();

        console.log(
            `%c MOUNT %c ${label} #${instanceId.current}`,
            "background:#0a7;color:#fff;border-radius:3px",
            "color:#0a7;font-weight:bold",
            mountedOn.current,
        );

        return () => {
            console.log(
                `%c UNMOUNT %c ${label} #${instanceId.current}`,
                "background:#c33;color:#fff;border-radius:3px",
                "color:#c33;font-weight:bold",
                `mounted on ${mountedOn.current} -> left from ${here()}`,
            );
        };
    }, []);
}
